import React from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSelector.css"; // Ajouter un fichier CSS pour styliser les drapeaux

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-selector me-3">
      <img
        src="/flags/en.png"
        alt="English"
        className={`flag-icon ${i18n.language === "en" ? "selected" : ""}`}
        onClick={() => changeLanguage("en")}
      />
      <img
        src="/flags/fr.jpg" // Chemin vers l'image du drapeau français
        alt="Français"
        className={`flag-icon ${i18n.language === "fr" ? "selected" : ""}`}
        onClick={() => changeLanguage("fr")}
      />
    </div>
  );
};

export default LanguageSelector;
